import _ from "lodash";
import React, { useState } from "react";

/** Components */
import { Modal, Button, TextInput } from "@toddle-edu/ds-web";

/** Utils */
import { documentTypeOptions } from "../modules/utils";

/** Styles */
import classes from "./NameModal.scss";
const customModalStyles = {
  body: { paddingBottom: "48px" },
};

const NameModal = ({
  t,
  closeModal,
  onDocumentNameSubmit,
  serviceType,
  documentType,
  fileType: fileTypeFromProps,
}) => {
  const [templateName, setTemplateName] = useState("");

  const handleNameInput = e => {
    setTemplateName(e?.target?.value);
  };

  const handleCreateDocument = () => {
    onDocumentNameSubmit({ name: templateName.trim() });
  };

  const fileType = fileTypeFromProps
    ? fileTypeFromProps
    : _.toLower(
        t(
          `common:${_.get(
            documentTypeOptions,
            `${documentType}.${serviceType}`,
            ""
          )}`
        )
      );

  return (
    <Modal
      dsVersion={"2.0"}
      hasOverlay
      onClose={closeModal}
      width={"480px"}
      height="fit-content"
    >
      <Modal.Header>
        <h5>{t("common:create_blank_file", { label: fileType })}</h5>
      </Modal.Header>
      <Modal.Body style={customModalStyles.body}>
        <div>
          <TextInput
            dsVersion={"2.0"}
            size="large"
            label={t("common:document_name")}
            value={templateName}
            placeholder={t("common:name_your_document")}
            onChange={handleNameInput}
            autoFocus={true}
          />
        </div>
      </Modal.Body>
      <Modal.Footer hasSeparator>
        <div className={classes.buttonContainer}>
          <Button
            dsVersion={"2.0"}
            size="medium"
            variant={"neutral"}
            type={"outlined"}
            onClick={closeModal}
          >
            {t("common:cancel")}
          </Button>
          <Button
            dsVersion={"2.0"}
            size="medium"
            variant={"primary"}
            type={"fill"}
            onClick={handleCreateDocument}
            shortcut={{ code: "Enter" }}
            disabled={_.isEmpty(_.trim(templateName))}
          >
            {t("common:create")}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default NameModal;
